import { connect } from 'react-redux';
import Booking from './Booking';
import {
  selectedOptionsChanged,
  additionalDiscussionChanged,
  requestTimeSlots,
  clearTimeSlots,
  storeReservation,
  resetBookingState,
  setReservationReasonCode, setSelectedTimeslot, unsetSelectedTimeslot
} from '../../actions/booking';
import { fetchUnitInfo } from '../../actions/ehrResources';
import { genericError } from '../../actions/errors';
import { clearSession } from '../../actions/session';

const mapStateToProps = (state) => {
  const { units, unitInfos } = state;
  Object.keys(unitInfos).forEach((key) => {
    if (units[key]) {
      units[key].info = unitInfos[key];
    }
  });

  return {
    userIdentified: state.session.userIdentified,
    canAnonymousFetchTimes: state.booking.canAnonymousFetchTimes,
    user: state.session.user,
    hasDepartment: state.session.hasDepartment,
    selectedEmployer: state.session.selectedEmployer,
    selectedDepartment: state.session.selectedDepartment,
    selectedOptionIds: state.booking.selectedOptionIds,
    additionalDiscussionChecked: state.booking.additionalDiscussionChecked,
    requestingTimeSlots: state.booking.requestingTimeSlots,
    timeSlotsRequested: state.booking.timeSlotsRequested,
    resources: state.resources,
    groups: state.groups,
    units,
    timeSlots: state.booking.timeSlots,
    storingReservation: state.booking.storingReservation,
    reservation: state.booking.reservation,
    reservationDone: state.booking.reservationDone,
    errorOccurred: !!Object.keys(state.errors).length,
    errors: state.errors,
    reservationByCodeEnabled: state.organization.reservationByCodeEnabled,
    prepareUserRegistration: state.session.prepareUserRegistration,
    pathNamespace: state.booking.pathNamespace,
    currentlyIdentifying: state.session.currentlyIdentifying,
    currentlyRegistering: state.session.currentlyRegistering,
    pathReservationByCodeEnabled: state.booking.pathReservationByCodeEnabled,
    utilizeEmployerInformation: state.booking.utilizeEmployerInformation,
    selectionHandler: state.booking.selectionHandler,
    pathLoaded: state.booking.pathLoaded,
    googleAnalyticsTrackingId: state.organization.googleAnalyticsTrackingId,
    selectedPathType: state.booking.selectedPathType,
    viaSso: state.session.viaSso,
    pathBasedBooking: state.booking.pathBasedBooking,
    selectedTicket: state.ticket.selectedTicket,
    hasSelectedTicket: state.ticket.hasSelectedTicket,
    selectedTicketCode: state.ticket.selectedTicketCode,
    optionalReservationText: state.organization.optionalReservationText,
    defaultLocale: state.organization.defaultLocale,
    legalEntity: state.booking.legalEntity,
    reservationReasonCode: state.booking.reservationReasonCode,
    loginPolicyType: state.organization.loginPolicyType,
    configurationLoaded: state.app.configurationLoaded,
    restoredState: state.booking.restoredState,
    selectedStoredTimeSlot: state.booking.selectedStoredTimeSlot,
    requiresEmployer: state.session.requiresEmployer,
    creationIncomplete: state.session.creationIncomplete,
    showOwnTeamByDefault: state.organization.showOwnTeamByDefault,
    smsConfirmationEnabled: state.organization.smsConfirmationEnabled,
    emailConfirmationEnabled: state.organization.emailConfirmationEnabled,
    calendarInfoFromServices: state.organization.calendarInfoFromServices
  };
};

const mapDispatchToProps = dispatch => ({
  selectedOptionsChanged(selectedOptionIds) {
    dispatch(selectedOptionsChanged(selectedOptionIds));
  },
  additionalDiscussionChanged(value) {
    dispatch(additionalDiscussionChanged(value));
  },
  fetchUnitInfo: dispatch(fetchUnitInfo),
  requestTimeSlots: dispatch(requestTimeSlots),
  clearTimeSlots() {
    dispatch(clearTimeSlots());
  },
  storeReservation: dispatch(storeReservation),
  logout: dispatch(clearSession),
  bookAgain: dispatch(resetBookingState),
  setReservationReasonCode: dispatch(setReservationReasonCode),
  setSelectedTimeslotToStore(timeslot) {
    dispatch(setSelectedTimeslot(timeslot));
  },
  unsetSelectedTimeslotToStore() {
    dispatch(unsetSelectedTimeslot());
  },
  showError(errorCode) {
    dispatch(genericError(errorCode));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Booking);



// WEBPACK FOOTER //
// ./src/containers/Booking/index.js